import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Form, Typography } from 'components/base';
import parseShippingType from '../lib/parseShippingType';

const CheckoutShippingTypes = props => {
  const className = classNames({
    'form-group-set': true,
    [props.className]: props.className,
  });

  const handleOnSelectShippingType = shippingType => {
    props.onChange(shippingType);
  };

  return (
    <div className={className}>
      {props.items.map(item => (
        <CheckoutShippingTypeItem
          key={item.type}
          active={props.active === item.type}
          onSelect={handleOnSelectShippingType}
          type={item.type}
          name={item.name}
          description={
            <>
              {item.description.split('\\n').map(row => (
                <Typography.Span key={row}>
                  {row}
                  <br />
                </Typography.Span>
              ))}
            </>
          }
          recommended={item.recommended}
        />
      ))}
    </div>
  );
};

CheckoutShippingTypes.propTypes = {
  active: PropTypes.number,
  items: PropTypes.array,
  className: PropTypes.string,
  onChange: PropTypes.func,
};

CheckoutShippingTypes.defaultProps = {
  items: [],
};

const CheckoutShippingTypeItem = props => {
  const className = classNames({
    'form-check': true,
    'form-check-card': true,
    active: props.active,
  });

  const handleOnChange = e => {
    props.onSelect(parseShippingType(e.target.value));
  };

  return (
    <Form.Group className="mb-0">
      <div className={className}>
        <input
          type="radio"
          id={`shippingType${props.type}`}
          checked={props.active}
          name="shippingType"
          className="form-check-input"
          value={props.type}
          onChange={handleOnChange}
        />
        <label className="label form-check-label" htmlFor={`shippingType${props.type}`}>
          <strong className="d-block text-black">
            {props.name}
            {props.recommended && ` (Recommended)`}
          </strong>
          {props.description}
        </label>
      </div>
    </Form.Group>
  );
};

CheckoutShippingTypeItem.propTypes = {
  active: PropTypes.bool,
  type: PropTypes.any,
  name: PropTypes.string,
  description: PropTypes.node,
  recommended: PropTypes.bool,
  onSelect: PropTypes.func,
};

export default CheckoutShippingTypes;
